import React, { FC } from 'react';
import { Button } from '@mui/material';
import { LabAction } from 'models/action';
import { useTranslation } from 'react-i18next';
import AddActionForm from './add-action-form.component';
import DHDialog from 'components/shared/dh-dialog/dh-dialog.component';

const FORM_ID = 'add-action-form';

type AddActionDialogProps = {
    dialogOpen: boolean;
    onCloseDialog: () => void;
    categories: { _id: string; name: string }[];
    groups: { _id: string; name: string }[];
    onAddAction: (action: LabAction) => void;
};
const AddActionDialog: FC<AddActionDialogProps> = ({
    dialogOpen,
    onCloseDialog,
    categories,
    groups,
    onAddAction,
}: AddActionDialogProps) => {
    const { t: translate } = useTranslation(['orders', 'common']);
    return (
        <DHDialog
            title={translate('orders:ADD_ACTION')}
            maxWidth="md"
            fullWidth
            open={dialogOpen}
            onClose={onCloseDialog}
            actions={
                <Button variant="contained" form={FORM_ID} type="submit">
                    {translate('common:SAVE')}
                </Button>
            }
        >
            <AddActionForm
                formId={FORM_ID}
                onCloseDialog={onCloseDialog}
                categories={categories}
                groups={groups}
                onAddAction={onAddAction}
            />
        </DHDialog>
    );
};

export default AddActionDialog;
